import React from 'react'
import { Spin } from 'antd'
import PropTypes from 'prop-types'
import { Wrapper, Title, TimeWrapper } from './styled'
import { convertSecondsToTime } from '../../../../utils'

const ViewingTime = ({ t, time, isLoading }) => {
  const { hours: sumHours, minutes: sumMinutes, seconds: sumSeconds } = convertSecondsToTime(time.sumStudyTime)
  const { hours: nissokenHours, minutes: nissokenMinutes, seconds: nissokenSeconds } = convertSecondsToTime(time.nissokenStudyTime)
  const { hours: companyHours, minutes: companyMinutes, seconds: companySeconds } = convertSecondsToTime(time.companyStudyTime)

  return (
    <Wrapper>
      <Title>{t('course_activity.viewing_time')}</Title>

      <Spin spinning={isLoading}>
        <TimeWrapper>
          <div className="time-box">
            <div className="time total">
              <span className="label">{t('course_activity.total')}</span>
              <span className="number">{sumHours.toLocaleString()}</span>
              {t('course_activity.hours')}
              <span className="number">{sumMinutes}</span>
              {t('course_activity.minutes')}
              <span className="number">{sumSeconds}</span>
              {t('course_activity.seconds')}
            </div>

            <div className="time jobnare">
              <span className="label">{t('course_activity.jobnare')}</span>
              <span className="number">{nissokenHours.toLocaleString()}</span>
              {t('course_activity.hours')}
              <span className="number">{nissokenMinutes}</span>
              {t('course_activity.minutes')}
              <span className="number">{nissokenSeconds}</span>
              {t('course_activity.seconds')}
            </div>

            <div className="time jobnavi">
              <span className="label">{t('course_activity.jobnavi')}</span>
              <span className="number">{companyHours.toLocaleString()}</span>
              {t('course_activity.hours')}
              <span className="number">{companyMinutes}</span>
              {t('course_activity.minutes')}
              <span className="number">{companySeconds}</span>
              {t('course_activity.seconds')}
            </div>
          </div>
        </TimeWrapper>
      </Spin>
    </Wrapper>
  )
}

ViewingTime.propTypes = {
  t: PropTypes.func.isRequired,
  time: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired
}

export default ViewingTime
